/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Dialog, DialogContent, DialogTitle, IconButton, Skeleton, useMediaQuery, useTheme,
} from '@mui/material';
import {
  FormDialogActions,
  FormElement,
  FormInputsStack,
  FormSubmissionError,
  FormCancelButton,
  FormSubmitButton,
  InputSkeleton,
  RichTextEditor,
  Icons,
} from '@marageti/z4-lib';
import { Controller } from 'react-hook-form';
import { ViewProps } from './types';

const EditUserFormView = ({
  errors,
  handleSubmit,
  open,
  onCancel,
  onSubmit,
  control,
  submissionError,
  partner,
  partnerDetail,
}: ViewProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('desktop'));
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="md"
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          backgroundColor: 'background.default',
          margin: 0,
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {partner?.name
          ? `Edit ${partnerDetail.displayName}`
          : <Skeleton variant="rounded" />}
        <IconButton
          aria-label="close editor"
          onClick={onCancel}
          style={{
            padding: 0,
            height: '24px',
            width: '24px',
          }}
        >
          <Icons.X color="primary" fontSize="small" />
        </IconButton>
      </DialogTitle>
      <FormElement name="partner-detail-editor-form" onSubmit={handleSubmit(onSubmit)}>
        <DialogContent sx={{ paddingTop: 1 }}>
          {!partner ? (
            <FormInputsStack>
              <InputSkeleton key={partnerDetail.attributeName} />
            </FormInputsStack>
          ) : (
            <FormInputsStack>
              {submissionError && <FormSubmissionError {...submissionError} />}
              <Controller
                control={control}
                name={partnerDetail.attributeName}
                render={({ field }) => (
                  <RichTextEditor
                    defaultValue={partner[partnerDetail.attributeName as keyof typeof partner] as string}
                    editorName={partnerDetail.attributeName}
                    error={!!errors[partnerDetail.attributeName]}
                    helperText={errors[partnerDetail.attributeName]?.message as string}
                    label={partnerDetail.displayName}
                    onChange={field.onChange}
                    sx={{
                      maxHeight: { mobile: 'calc(100vh - 256px)', desktop: 'calc(100vh - 500px)' },
                      flex: 1,
                    }}
                    useLinks
                    useLists
                  />
                )}
              />
            </FormInputsStack>
          )}
        </DialogContent>
        <FormDialogActions>
          <FormCancelButton onClick={onCancel} />
          <FormSubmitButton />
        </FormDialogActions>
      </FormElement>
    </Dialog>
  );
};

export default EditUserFormView;
